const SvgIconEdit = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M12.5002 5.12345L15.0002 7.59693M10.8335 16.6663H17.5002M4.16683 13.3684L3.3335 16.6663L6.66683 15.8418L16.3218 6.28928C16.6343 5.98005 16.8098 5.5607 16.8098 5.12345C16.8098 4.6862 16.6343 4.26685 16.3218 3.95762L16.1785 3.81581C15.866 3.50667 15.4421 3.33301 15.0002 3.33301C14.5582 3.33301 14.1344 3.50667 13.8218 3.81581L4.16683 13.3684Z"
        stroke="#514B4D"
        strokeWidth="1.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgIconEdit;
